// @flow
import { buildOptions, makeRequest } from './ServiceHelpers';
import { auth } from '../utils/auth';
import get from 'lodash/get';

const endpointUrl = process.env.REACT_APP_COAM_URL;

export const CLAIM_USER_CANONICAL_ID = 'https://claims.cimpress.io/canonical_id';

export const fetchIdentityPermissions = () => {
  const options = buildOptions();
  const canonicalId = auth.getProfile()[CLAIM_USER_CANONICAL_ID];

  return makeRequest(endpointUrl, `/principals/${canonicalId}/permissions`, options, 'fetching coam permissions').then(
    permissions => {
      let fulfillerPermissionMap = {};
      let merchantPermissionMap = {};

      // If we got any permissions back
      if (permissions) {
        if (permissions.fulfillers) {
          fulfillerPermissionMap = permissions.fulfillers.reduce((map, { identifier, permissions }) => {
            map[identifier] = permissions;
            return map;
          }, {});
        }

        // If we got merchant permissions
        if (permissions.merchants) {
          merchantPermissionMap = permissions.merchants.reduce((map, { identifier, permissions }) => {
            map[identifier] = permissions;
            return map;
          }, {});
        }
      }

      return {
        fulfillerPermissionMap,
        merchantPermissionMap
      };
    }
  );
};

export const fetchUserProfile = userSub => {
  const options = buildOptions();

  return makeRequest(
    endpointUrl,
    `/principals/${encodeURI(userSub)}?responseFilter=groups%2Cpermissions&include=false`,
    options,
    'fetching user profile'
  ).then(res => get(res, 'profile.email', userSub));
};
